<!--图像抓拍-->
<template>
  <div>
    <div>
      <div style="display: flex; align-items: center">
        <el-tabs v-model="activeName">
          <el-tab-pane :label="$t('photom.PhotoSnapshot')" name="first"></el-tab-pane>
          <el-tab-pane :label="$t('photom.historicalphotoQuery')" name="second"></el-tab-pane>
        </el-tabs>
        <div v-if="activeName === 'first'">
          <span style="
              margin-left: 6px;
              font-weight: normal;
              color: #ff8c00;
              font-size: 12px;
            "><kl-icon :size="12" icon="icon-icon_prompt2" />{{
              $t("photom.selectVehicleTip")
            }}</span>
        </div>
        <div v-if="activeName === 'first'" style="flex: 1; text-align: right">
          <el-form :inline="true" size="small" style="flex: 1; text-align: right">
            <el-form-item :label="$t('photom.selectCamera')">
              <el-select :placeholder="$t('photom.selectCamera')" v-model="CameraList" style="width: 160px">
                <el-option :label="$t('photom.camera1')" value="1"></el-option>
                <el-option :label="$t('photom.camera2')" value="2"></el-option>
                <el-option :label="$t('photom.camera3')" value="3"></el-option>
                <el-option :label="$t('photom.camera4')" value="4"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('photom.capturedNumbers')">
              <el-input-number v-model="PhotoNum" :min="1" :max="10"></el-input-number>
            </el-form-item>
            <el-form-item>
              <kl-label :title="$t('photom.AdvancedOptions')" @click="onShowAdvancedOption" :iconSize="16"
                :fontSize="12" style="margin-right: 12px; cursor: pointer" icon="icon-icon_operat_settin" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handlePhotoClick" plain>{{
                $t("photom.Snapshot")
              }}</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="activeName === 'second'" style="flex: 1; text-align: right">
          <el-form :inline="true" size="small" style="flex: 1; text-align: right">
            <el-form-item :label="$t('photom.EventType')">
              <el-select :placeholder="$t('photom.EventType')" v-model="EventType" style="width: 160px">
                <el-option :label="$t('photom.EventType1')" value="0"></el-option>
                <el-option :label="$t('photom.EventType2')" value="1"></el-option>
                <el-option :label="$t('photom.EventType3')" value="2"></el-option>
                <el-option :label="$t('photom.EventType4')" value="3"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('time.timeQuery')">
              <el-date-picker v-model="EventTime" type="datetimerange" :range-separator="$t('time.to')"
                :start-placeholder="$t('time.startDate')" :end-placeholder="$t('time.endDate')"
                value-format="yyyy-MM-dd HH:mm:ss" />
            </el-form-item>

            <el-form-item>
              <el-button type="primary" plain @click="onSearchHistory">{{
                $t("public.query")
              }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <el-divider></el-divider>
    <div v-if="activeName === 'second'" style="">
      <div>
        <limittitleitem style="margin-top: 20px" :title="$t('photom.Imagelist')" icon="icon-icon_operat_image" />
      </div>
      <div style="height: calc(100vh - 260px); overflow-y: auto" v-loading="loading">
        <el-row v-infinite-scroll="loadMore" :gutter="20" v-if="HistoryPhotoList.length > 0" style="margin-right: 0px">
          <el-col style="margin-top: 16px" :span="4" v-for="n in HistoryPhotoList" :key="n.PhotoId">
            <ImageShowItem :photo="n" />
          </el-col>
        </el-row>
        <el-empty v-else :description="$t('statistics.noData')"></el-empty>
      </div>
    </div>
    <div v-if="activeName === 'first'" style="">
      <div>
        <limittitleitem style="margin-top: 20px" :title="$t('photom.Imagelist')" icon="icon-icon_operat_image" />
      </div>
      <div style="height: calc(100vh - 480px); overflow-y: auto">
        <el-row v-if="RealTimePhotoList.length > 0" :gutter="20" style="margin-right: 0px">
          <el-col style="margin-top: 16px" :span="4" v-for="n in RealTimePhotoList" :key="n.PhotoId">
            <ImageShowItem :photo="n" />
          </el-col>
        </el-row>
        <el-empty v-else :description="$t('statistics.noData')"></el-empty>
      </div>
    </div>

    <div v-if="activeName === 'first'">
      <div>
        <limittitleitem style="margin-top: 16px; margin-bottom: 16px" :title="$t('photom.Progressdisplay')"
          icon="icon-icon_tab_list" />
      </div>
      <div style="height: 170px; overflow-y: auto">
        <el-table size="mini" :data="LogList" border style="width: 100%">
          <el-table-column type="index" width="45" align="center" :label="$t('public.index')">
          </el-table-column>
          <el-table-column prop="vehicleName" align="center" :label="$t('vehicle.carNo')">
          </el-table-column>
          <el-table-column prop="mobile" align="center" :label="$t('vehicle.DeviceNo')">
          </el-table-column>
          <el-table-column prop="photoTotal" align="center" :label="$t('photom.totalNumbers')">
          </el-table-column>
          <el-table-column prop="photoIndex" align="center" :label="$t('photom.CurrentPhoto')">
          </el-table-column>
          <el-table-column prop="progress" align="center" :label="$t('photom.ReciveProcess')">
          </el-table-column>
          <el-table-column prop="remark" align="center" :label="$t('photom.beizhu')">
          </el-table-column>
          <el-table-column prop="operaton" align="center" :label="$t('public.Operation')">
            <template slot-scope="scope">
              <el-link v-if="scope.row.operation == 1" :underline="false" @click="stopPhoto(scope.row)"
                type="primary">{{ $t("public.cancel") }}</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :title="$t('photom.AdvancedOptions')" :visible.sync="dialogVisible" width="350px">
      <div style="padding: 0 20px">
        <div style="text-align: left">
          <div style="margin-bottom: 16px">
            <span style="font-weight: bold; font-size: 12px; color: #0f1a3a">{{
              $t("photom.AdvancedOptions")
            }}</span>
          </div>
          <el-form :size="size" label-width="80px">
            <el-form-item :label="$t('photom.resolution')">
              <el-select :placeholder="$t('photom.resolution')" v-model="Resolution">
                <el-option label="320*240" value="1"></el-option>
                <el-option label="640*480" value="2"></el-option>
                <el-option label="800*600" value="3"></el-option>
                <el-option label="1024*768" value="4"></el-option>
                <el-option label="176*144[Qcif]" value="5"></el-option>
                <el-option label="352*288[Cif]" value="6"></el-option>
                <el-option label="704*288[HALF D1]" value="7"></el-option>
                <el-option label="704*576[D1]" value="8"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('photom.quality')">
              <el-select :placeholder="$t('photom.quality')" v-model="Quality">
                <el-option label="1" value="1"></el-option>
                <el-option label="2" value="2"></el-option>
                <el-option label="3" value="3"></el-option>
                <el-option label="4" value="4"></el-option>
                <el-option label="5" value="5"></el-option>
                <el-option label="6" value="6"></el-option>
                <el-option label="7" value="7"></el-option>
                <el-option label="8" value="8"></el-option>
                <el-option label="9" value="9"></el-option>
                <el-option label="10" value="10"></el-option>
              </el-select>
            </el-form-item>
            <limitvalueset :label="$t('photom.cameraInterval')" v-model="Interval" :max="100" :min="1" unit="秒" />
            <limitvalueset :label="$t('photom.brightness')" unit="0~255" v-model="Brightness" :max="255" :min="0" />
            <limitvalueset :label="$t('photom.contrast')" v-model="Contrast" unit="0~127" :max="127" :min="0" />
            <limitvalueset :label="$t('photom.saturation')" unit="0~127" v-model="Saturation" :max="127" :min="0" />
            <limitvalueset :label="$t('photom.chroma')" unit="0~255" v-model="Chroma" :max="255" :min="0" />
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" :size="size">{{
          $t("public.cancel")
        }}</el-button>
        <el-button type="primary" @click="dialogVisible = false" :size="size">{{
          $t("public.confirm")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ImageShowItem from "./components/ImageShowItem.vue";
import limittitleitem from "../speedlimit/components/limittitleitem";
import limitvalueset from "../speedlimit/components/limitvalueset";
import { mapState } from "vuex";
import { HashTable } from "@/utils/HashTable";
import { queryVideoDeviceNoRecorder } from "@/http/vehicle";

export default {
    name:"VehiclePhotoCapture",
  components: {
    limitvalueset,
    limittitleitem,
    ImageShowItem,
  },
  computed: {
    ...mapState({
      selectedVehicles: (state) => state.app.vehicles.selectedVehicles,
    }),
    size() {
      return this.$store.getters.size;
    },
  },
  data() {
    return {
      EventType: "0",
      EventTime: "",
      HistoryPhotoList: [],
      PageNo: 1,
      RealTimePhotoList: [], //实时的图片列表
      PhotoNum: 1, //抓拍照片数量
      CameraList: [], //摄像头列表
      Interval: 30, //拍照间隔，默认30秒
      Quality: "1", //图片质量
      Resolution: "1", //分辨率
      Brightness: 130,
      Contrast: 65,
      Saturation: 65,
      Chroma: 130,
      LogList: [], //拍照的进度列表
      VehicleSendQueue: null,
      dialogVisible: false,
      loading: false,
      activeName: "first",
    };
  },
  created() {
    this.VehicleSendQueue = new HashTable();
    this.socketClient.AttachEvent(
      "VehiclePhotoCapture",
      this.socketClient.eventType.onTakePhotoAck,
      this.takePhotoAck
    );
    this.socketClient.AttachEvent(
      "VehiclePhotoCapture",
      this.socketClient.eventType.onReceiveMultiMediaAbnormal,
      this.receiveMultiMediaAbnormal
    );
    this.socketClient.AttachEvent(
      "VehiclePhotoCapture",
      this.socketClient.eventType.onReceivePhoto,
      this.receivePhoto
    );
    this.socketClient.AttachEvent(
      "VehiclePhotoCapture",
      this.socketClient.eventType.onReceivePhotoComplete,
      this.receivePhotoComplete
    );
  },
  destroyed() {
    this.socketClient.DetachEvent(
      "VehiclePhotoCapture",
      this.socketClient.eventType.onTakePhotoAck
    );
    this.socketClient.DetachEvent(
      "VehiclePhotoCapture",
      this.socketClient.eventType.onReceivePhoto
    );
    this.socketClient.DetachEvent(
      "VehiclePhotoCapture",
      this.socketClient.eventType.onReceivePhotoComplete
    );
    this.socketClient.DetachEvent(
      "VehiclePhotoCapture",
      this.socketClient.eventType.onReceiveMultiMediaAbnormal
    );
  },
  methods: {
    onShowAdvancedOption() {
      this.Interval = 30;
      this.Quality = "1";
      this.Resolution = "1";
      this.Brightness = 130;
      this.Contrast = 65;
      this.Saturation = 65;
      this.Chroma = 130;

      this.dialogVisible = true;
    },
    stopPhoto(row) {
      //mobile
      var mobile = row.mobile;

      if (mobile != "") {
        var vehicleItem = this.VehicleSendQueue.items(mobile);
        if (vehicleItem != undefined) {
          this.$confirm(
            this.$t("photom.cancelRequest"),
            this.$t("public.tips"),
            {
              confirmButtonText: this.$t("public.confirm"),
              cancelButtonText: this.$t("public.cancel"),
              type: "warning",
            }
          )
            .then(() => {
              //取消图像抓拍命令的代码
              if (vehicleItem.cameraIndex < vehicleItem.Channels.length)
                this.socketClient.socket.takePhotoReq(
                  vehicleItem.mobile,
                  vehicleItem.Channels[vehicleItem.cameraIndex],
                  0,
                  vehicleItem.interval,
                  vehicleItem.saveMode,
                  vehicleItem.resolution,
                  vehicleItem.quality,
                  vehicleItem.brightness,
                  vehicleItem.contrast,
                  vehicleItem.saturation,
                  vehicleItem.color
                );

              vehicleItem.finished = true;

              this.VehicleSendQueue.update(mobile, vehicleItem);

              var rows = this.LogList;
              for (var i = 0; i < rows.length; i++) {
                if (rows[i].mobile == mobile) {
                  rows[i].photoIndex = "";
                  rows[i].photoTotal = "";
                  rows[i].remark = "";
                  rows[i].progress = "";
                  rows[i].operation = 0;
                  // $("#LogList").datagrid("refreshRow", i);
                  break;
                }
              }
            })
            .catch(() => { });
        }
      }
    },
    takePhotoAck(params) {
      //开启抓拍应答
      console.log(params);
      if (params != undefined) {
        var vehicleItem = this.VehicleSendQueue.items(params.mobile);
        console.log(vehicleItem);

        if (vehicleItem == null || vehicleItem.finished) return;
        if (parseInt(vehicleItem.msgId) != parseInt(params.msgId)) return;

        if (params.result != 0) {
          if (vehicleItem != undefined) {
            vehicleItem.finished = true;
            this.VehicleSendQueue.update(params.mobile, vehicleItem);
            // var winFrame = window.frames["Photo" + vehicleItem.name];
            // winFrame.showWaitting(false);
          }
        }

        var rows = this.LogList;
        console.log(rows);
        for (var i = 0; i < rows.length; i++) {
          console.log(rows[i]);
          if (rows[i].mobile == params.mobile) {
            var strProgress = this.$t("public.tips");
            switch (params.result) {
              case 0:
                strProgress = this.$t("deviceresponse.collection");
                break;
              case 1:
                strProgress = this.$t("deviceresponse.photoFailed");
                break;
              case 2:
                strProgress = this.$t("deviceresponse.msgError");
                break;
              case 3:
                strProgress = this.$t("deviceresponse.noSupport");
                break;
              case 4:
                strProgress = this.$t("deviceresponse.alarmConfirmation");
                break;
              case 0x80:
                strProgress = this.$t("deviceresponse.offLine");
                break;
              case 0x81:
                strProgress = this.$t("deviceresponse.noAnswer");
                break;
            }

            rows[i].remark = strProgress;
            rows[i].progress = strProgress;
            if (params.result != 0) {
              rows[i].operation = 0;
            }
            // $('#LogList').datagrid('refreshRow', i);
          }
        }
      }
    },
    receiveMultiMediaAbnormal(params) {
      //异常终止
      console.log(params);
      if (params != undefined) {
        var vehicleItem = this.VehicleSendQueue.items(params.mobile);
        if (vehicleItem == null || vehicleItem.finished) return;
        if (vehicleItem.msgId != params.msgId) return;

        if (params.result != 0) {
          if (vehicleItem != undefined) {
            vehicleItem.finished = true;
            this.VehicleSendQueue.update(params.mobile, vehicleItem);
          }
        }

        var rows = this.LogList;
        for (var i = 0; i < rows.length; i++) {
          if (rows[i].mobile == params.mobile) {
            var strProgress = this.$t("deviceresponse.unknown");
            switch (params.result) {
              case 2:
                strProgress = this.$t("deviceresponse.noAnswer");
                break;
              case 3:
                strProgress = this.$t("deviceresponse.disconnect");
                break;
              case 4:
                strProgress = this.$t("deviceresponse.accInvalid");
                break;
            }

            rows[i].remark = strProgress;
            rows[i].progress = strProgress;
            if (params.result != 0) {
              rows[i].operation = 0;
            }
            // $('#LogList').datagrid('refreshRow', i);
          }
        }
      }
    },
    receivePhoto(params) {
      //经度接收
      console.log(params);
      if (params != undefined) {
        var vehicleItem = this.VehicleSendQueue.items(params.mobile);
        if (vehicleItem == null || vehicleItem.finished) return;
        if (vehicleItem.msgId != params.msgId) return;

        var rows = this.LogList;
        for (var i = 0; i < rows.length; i++) {
          if (rows[i].mobile == params.mobile) {
            var strProgress = params.currentRecord + "/" + params.totalRecord;
            rows[i].progress = strProgress;
          }
        }
      }
    },
    receivePhotoComplete(params) {
      //抓拍完成
      console.log(params);
      if (params != undefined) {
        var vehicleItem = this.VehicleSendQueue.items(params.mobile);
        if (vehicleItem == null || vehicleItem.finished) return;
        if (vehicleItem.msgId != params.msgId) return;
        if (vehicleItem != undefined) {
          //查询图片
          if (params.url != "") {
            var url = params.url.replace(
              "http://pic.kingwings.cn:7350",
              "//ws.kingwings.cn/pic"
            );
            var rows = this.LogList;

            for (var j = 0; j < rows.length; j++) {
              if (rows[j].mobile == params.mobile) {
                rows[j].remark = this.$t("photom.photoreceived", {
                  n: vehicleItem.photoIndex,
                });
              }
            }
            console.log(url);
            this.RealTimePhotoList.push({
              FileUrl: url,
              PhotoId: params.msgId,
              CarNo: vehicleItem.name,
            });
          }

          var i = vehicleItem.photoIndex % vehicleItem.photoNum;
          if (vehicleItem.photoIndex < vehicleItem.photoTotal) {
            //未传完毕
            //发送下一个摄像头抓拍命令到车台
            if (
              i == 0 &&
              vehicleItem.cameraIndex < vehicleItem.Channels.length
            ) {
              vehicleItem.cameraIndex++;
              i = this.socketClient.socket.takePhotoReq(
                vehicleItem.mobile,
                vehicleItem.Channels[vehicleItem.cameraIndex],
                vehicleItem.photoNum,
                vehicleItem.interval,
                vehicleItem.saveMode,
                vehicleItem.resolution,
                vehicleItem.quality,
                vehicleItem.brightness,
                vehicleItem.contrast,
                vehicleItem.saturation,
                vehicleItem.color
              );
              if (!i) return false;
              vehicleItem.msgId = i;
            }

            vehicleItem.photoIndex++; //累加当前抓拍序号

            var rows = this.LogList;
            for (var j = 0; j < rows.length; j++) {
              if (rows[j].mobile == params.mobile) {
                rows[j].photoIndex = this.$t("photom.photoindex", {
                  n: vehicleItem.photoIndex,
                });
                rows[j].remark = this.$t("photom.Waitingresponse");
                rows[j].progress = "0/0";
              }
            }
          } else {
            vehicleItem.finished = true;
            this.VehicleSendQueue.update(params.mobile, vehicleItem);
            rows[i].operation = 0;
          }
        }
      }
    },
    async handlePhotoClick() {
      //图片抓拍
      /**
      1、选择车辆
2、下发拍照指令
3、接受拍照指令反馈
4、显示进度
5、显示拍照结果
*/

      var cars = this.selectedVehicles;
      if (cars.length == 0) {
        this.$message.warning(this.$t("photom.selectVehicleTip"));

        return;
      }

      if (this.PhotoNum == "" || this.PhotoNum <= 0) {
        this.$message.warning(this.$t("photom.plsphotonumber"));
        return;
      }
      if (this.CameraList.length == 0) {
        this.$message.warning(this.$t("photom.plscameralist"));
        return;
      }

      var photoNum = parseInt(this.PhotoNum);
      var Cameras = this.CameraList; //选中的摄像头通道
      var cameraNum = Cameras.length;
      var uiInterval = this.Interval; //
      var uiQuality = this.Quality; //
      var uiResolution = this.Resolution; // 分辨率
      var uiBrightness = this.Brightness; //亮度
      var uiContrast = this.Contrast; //对比度
      var uiSaturation = this.Saturation; //饱和度
      var uiColor = this.Chroma; //色度

      var car,
        row,
        resultMsgId,
        errorCars = "";
      var rows = this.LogList;
      console.log(cars);
      for (var i = 0; i < cars.length; i++) {
        //没有抓拍过
        car = cars[i];
        console.log(car);
      //  car.manuID="S6A00148" //todo 测试用
        const res = await queryVideoDeviceNoRecorder({
          ManufactureID: car.manuID,
        });
        // .then((res) => {
        //   // console.log(res);
        //   if (res.code == 200 && res.data.length > 0 && res.data[0].DeviceNo != "") {

        //     car.mobile = res.data[0].DeviceNo;




        //   }
        // });
        car.mobile = res.data[0].DeviceNo;

        if (!this.VehicleSendQueue.contains(car.mobile)) {
          //入队列
          this.VehicleSendQueue.add(car.mobile, {
            mobile: car.mobile, //终端编号
            name: car.vehicleName, //车牌号
            Channels: Cameras, //要抓拍的摄像头数组
            cameraIndex: 0, //当前接收的摄像头序号,数组下标
            photoTotal: Cameras.length * photoNum, //此次抓拍的照片总数
            photoNum: photoNum, //每个摄像头抓拍数量
            photoIndex: 1, //第几张图片
            msgId: 0,
            finished: false, //是否完成拍照
            interval: uiInterval, //拍照间隔/录像时间 单位秒，0表示按最小间隔拍照或一直录像
            saveMode: 0, //保存标志 1：保存； 0：实时上传
            resolution: uiResolution, //分辨率
            quality: uiQuality, //图像质量
            brightness: uiBrightness, //亮度
            contrast: uiContrast, //对比度
            saturation: uiSaturation, //饱和度
            color: uiColor, //色度
          });

          //发送第一个摄像头到车台
          var vehicleItem = this.VehicleSendQueue.items(car.mobile);
          console.log(vehicleItem);
          if (this.socketClient && this.socketClient.socket)
            resultMsgId = this.socketClient.socket.takePhotoReq(
              car.mobile,
              vehicleItem.Channels[vehicleItem.cameraIndex],
              vehicleItem.photoNum,
              vehicleItem.interval,
              vehicleItem.saveMode,
              vehicleItem.resolution,
              vehicleItem.quality,
              vehicleItem.brightness,
              vehicleItem.contrast,
              vehicleItem.saturation,
              vehicleItem.color
            );
          console.log(resultMsgId);
          if (!resultMsgId) return false;

          vehicleItem.msgId = resultMsgId;
          row = {
            vehicleName: car.vehicleName,
            mobile: car.mobile,
            photoTotal: vehicleItem.photoTotal,
            photoIndex: this.$t("photom.photoindex", {
              n: 1,
            }),
            progress: this.$t("photom.Waitingresponse"),
            msgId: resultMsgId,
            operation: 1,
          };
          this.LogList.push(row);
        } else {
          //已经存在的车辆

          var vehicleItem = this.VehicleSendQueue.items(car.mobile);
          console.log(vehicleItem);
          if (vehicleItem.finished) {
            //上次图像抓拍完成，可以继续下发
            vehicleItem.Channels = Cameras; //要抓拍的摄像头数组
            vehicleItem.cameraIndex = 0; //当前接收的摄像头序号,数组下标
            vehicleItem.photoTotal = Cameras.length * photoNum; //此次抓拍的照片总数
            vehicleItem.photoNum = photoNum; //每个摄像头抓拍数量
            vehicleItem.photoIndex = 1; //第几张图片
            vehicleItem.finished = false; //未完成
            vehicleItem.interval = uiInterval; //拍照间隔/录像时间 单位秒，0表示按最小间隔拍照或一直录像
            vehicleItem.saveMode = 0; //保存标志 1：保存； 0：实时上传
            vehicleItem.resolution = uiResolution; //分辨率
            vehicleItem.quality = uiQuality; //图像质量
            vehicleItem.brightness = uiBrightness; //亮度
            vehicleItem.contrast = uiContrast; //对比度
            vehicleItem.saturation = uiSaturation; //饱和度
            vehicleItem.color = uiColor; //色度

            this.VehicleSendQueue.update(car.mobile, vehicleItem);
            //发送第一个摄像头到车台
            if (this.socketClient && this.socketClient.socket)
              resultMsgId = this.socketClient.socket.takePhotoReq(
                car.mobile,
                vehicleItem.Channels[vehicleItem.cameraIndex],
                vehicleItem.photoNum,
                vehicleItem.interval,
                vehicleItem.saveMode,
                vehicleItem.resolution,
                vehicleItem.quality,
                vehicleItem.brightness,
                vehicleItem.contrast,
                vehicleItem.saturation,
                vehicleItem.color
              );

            if (!resultMsgId) return false;

            vehicleItem.msgId = resultMsgId;
            for (var k = 0; k < rows.length; k++) {
              if (rows[k].mobile == vehicleItem.mobile) {
                rows[k].photoIndex = this.$t("photom.photoindex", {
                  n: vehicleItem.photoIndex,
                });
                rows[k].photoTotal = vehicleItem.photoTotal;
                rows[k].progress = "0/0";
                rows[k].remark = this.$t("photom.Waitingresponse");
                rows[k].msgId = resultMsgId;
                rows[k].operation = 1;
              }
            }
          } else {
            //车辆正在抓拍，不能继续下发
            errorCars += vehicleItem.name + ",";
          }
        }
      }

      if (errorCars != "") {
        errorCars = errorCars.substr(0, errorCars.length - 1);
        errorCars += this.$t("photom.previsnotover");
        this.$message.warning(errorCars);
      }
    },
    getSelectedVehicles() {
      var vehicles = "";
      for (let k = 0; k < this.selectedVehicles.length; k++) {
        if (this.selectedVehicles[k].treeLevel == 5) {
          vehicles = vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return vehicles.substring(0, vehicles.length - 1);
    },
    loadMore() {
      this.PageNo++;
      this.queryHistoryList();
    },
    onSearchHistory() {
      this.HistoryPhotoList = [];
      this.PageNo = 1;
      this.queryHistoryList();
    },
    queryHistoryList() {
      //查询历史照片记录
      if (this.EventTime.length == 0) {
        //请选择时间范围
        this.$message.warning(this.$t("photom.plsselectime"));
        return;
      }
      var vids = this.getSelectedVehicles();
      if (vids.length == 0) {
        this.$message.warning(this.$t("photom.selectVehicleTip"));
        return;
      }

      var beginTime = this.EventTime[0];
      var endTime = this.EventTime[1];

      this.loading = true;
      // vids="162075";//"162072" //todo 测试用
      this.$api
        .queryHistoryPhotoList({
          beginTime: beginTime,
          endTime: endTime,
          vehicleIds: vids,
          eventType: this.EventType,
          PageNo: this.PageNo,
          PageSize: 20,
        })
        .then((res) => {
            this.loading = false;
          console.log(res);
          if (res.data && res.data.length > 0) {
            res.data.forEach((element) => {
              this.HistoryPhotoList.push(element);
            });
          }
        });
    },
  },
  mounted() {
    this.EventTime = [this.moment().subtract(7, 'days').format('YYYY-MM-DD 00:00:00'), this.moment().format('YYYY-MM-DD 23:59:59')];

  },
};
</script>
